module.exports = __webpack_public_path__ + "img/icon-export-csv.6c4d03c1.svg";